import React from "react";
import { connect, useDispatch } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import Page from "components/Page";
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Button,
  CardGroup,
  CardHeader
} from 'reactstrap';
import { tokenIframe } from "../../redux/actions/aContenidos";
import {stringABase64} from "../../utils/Encriptar"

// import { IconWidget } from 'components/Widget';
// import {

//   MdRateReview,
//   MdThumbUp,
// } from 'react-icons/lib/md';
// import { R_OK } from "constants";

class Principal extends React.Component {

  

  constructor(props){
    super(props)
    this.state = {
      token: ""
    }
  }

  onCompras = () => {
    this.props.history.replace({
      pathname: `/listado-compras`
    });
  }
  
  onCotizaciones = () => {

    this.props.history.replace({
      pathname: `/listado-cotizaciones`
    });
  }
  

  async componentDidMount() {
    await tokenIframe();
  }

  render() {


    //Renovaciones COndiciones
    let bloquearRenovaciones = true;


    if (
      (this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "canal-user" ||
        this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "asesor-user" ||
        this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "admin-user") &&
      this.props.datosUsuario.dataUsuario.userIsLoggedIn === true
    ) {
      bloquearRenovaciones = false;
    }

    let bloquearOpciones = false;

    console.log('this.props.datosUsuario.dataUsuario.usu_tipo_usuario', this.props.datosUsuario.dataUsuario.usu_tipo_usuario)

    if (this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "cliente") {
      bloquearRenovaciones = true
      bloquearOpciones = true;
    }


    return (
      <Page title="Inicio" breadcrumbs={[{ name: "inicio", active: true }]}>
        <Row>
          <Col lg={6} md={12} sm={12} xs={12}>
            <Col lg={12} md={12} sm={12} xs={12}>
              <Card className={"cr-widget bg-light card background-white"} >
                <Row style={{ width: "50%", textAlign: "center" }}>
                  <Col lg={12} md={12} sm={12} xs={12} style={{ padding: "0.5em" }}>
                    <div style={{ textAlign: "center" }}><i className="fa fa-file-pdf-o fa-3x" aria-hidden="true" style={{ color: "#001871" }}></i></div>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={12} style={{ padding: "0.5em" }}>
                    <span className="mr-1 badge badge-info badge-pill" style={{ fontSize: "1.5em", background: "#001871", marginTop: "0.3em" }}>
                      {this.props.datosDashboard.datosDashboard.contadorPolizas && this.props.datosDashboard.datosDashboard.contadorPolizas !== undefined ? this.props.datosDashboard.datosDashboard.contadorPolizas : 0}
                    </span>
                  </Col>
                </Row>
                <Row style={{ width: "50%", textAlign: "center" }}>
                  <Col lg={12} md={12} sm={12} xs={12} style={{ padding: "0.5em" }}>
                    <CardTitle>CONSULTA</CardTitle>
                    {this.props.datosUsuario.dataUsuario && this.props.datosUsuario.dataUsuario.usu_tipo_usuario && this.props.datosUsuario.dataUsuario.usu_tipo_usuario !== 'cliente' &&
                      <CardTitle>TUS VENTAS</CardTitle>
                    }
                    {this.props.datosUsuario.dataUsuario && this.props.datosUsuario.dataUsuario.usu_tipo_usuario && this.props.datosUsuario.dataUsuario.usu_tipo_usuario === 'cliente' &&
                      <CardTitle>TUS COMPRAS</CardTitle>
                    }
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={12} style={{ padding: "0.5em" }}>
                    <Button className={"btn btn-primary"} onClick={this.onCompras} style={{ display: "block", margin: "auto" }} >
                      <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                      {this.props.datosUsuario.dataUsuario && this.props.datosUsuario.dataUsuario.usu_tipo_usuario && this.props.datosUsuario.dataUsuario.usu_tipo_usuario !== 'cliente' && "Ver Ventas"}
                      {this.props.datosUsuario.dataUsuario && this.props.datosUsuario.dataUsuario.usu_tipo_usuario && this.props.datosUsuario.dataUsuario.usu_tipo_usuario === 'cliente' && "Ver Compras"}
                    </Button>
                  </Col>
                </Row>
              </Card>
            </Col>
            <Col lg={12} md={12} sm={12} xs={12}>
              <Card className={"cr-widget bg-light card background-white"} >
                <Row style={{ width: "50%", textAlign: "center" }}>
                  <Col lg={12} md={12} sm={12} xs={12} style={{ padding: "0.5em" }}>
                    <div style={{ textAlign: "center" }}><i className="fa fa-file-text-o fa-3x" aria-hidden="true" style={{ color: "#001871" }}></i></div>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={12} style={{ padding: "0.5em" }}>
                    <span className="mr-1 badge badge-info badge-pill" style={{ fontSize: "1.5em", background: "#001871", marginTop: "0.3em" }}>
                      {this.props.datosDashboard.datosDashboard.contadorCotizaciones && this.props.datosDashboard.datosDashboard.contadorCotizaciones !== undefined ? this.props.datosDashboard.datosDashboard.contadorCotizaciones : 0}
                    </span>
                  </Col>
                </Row>
                <Row style={{ width: "50%", textAlign: "center" }}>
                  <Col lg={12} md={12} sm={12} xs={12} style={{ padding: "0.5em" }}>
                    <CardTitle>CONSULTA</CardTitle>
                    <CardTitle>TUS COTIZACIONES</CardTitle>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={12} style={{ padding: "0.5em" }}>
                    <Button className={"btn btn-primary"} onClick={this.onCotizaciones} style={{ display: "block", margin: "auto" }} >
                      <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                      {"Ver Cotizaciones"}
                    </Button>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Col>

          <Col lg={6} md={12} sm={12} xs={12}>
            <Card>
              <CardHeader>Menú de Servicios</CardHeader>
              <CardBody>
                <CardGroup>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Link to={bloquearOpciones ? null : `/lista-cotizadores`}>
                      <div className={bloquearOpciones?"cr-widget card background-cards-servicios-disabled":"cr-widget card background-cards-servicios"}>
                        <div className="card-body">
                     
                          <h5 className="card-title" style={{ color: "white" }}>Cotizadores</h5>
                        </div>
                        <div className="cr-widget__icon card-body">
                          <i className="fa fa-globe fa-2x background-cards-iconos" aria-hidden="true"></i>
                        </div>
                      </div>
                    </Link>
                  </Col>

                  {bloquearRenovaciones && (
                    <Col lg={6} md={6} sm={12} xs={12}>
                      <div className="cr-widget card background-cards-servicios-disabled">
                        <div className="card-body">
                          <h5 className="card-title" style={{ color: "white" }}>Renovaciones</h5>
                        </div>
                        <div className="cr-widget__icon card-body">
                          <i className="fa fa-refresh fa-2x background-cards-iconos" aria-hidden="true"></i>
                        </div>
                      </div>
                    </Col>
                  )}
                  {!bloquearRenovaciones && (
                    <Col lg={6} md={6} sm={12} xs={12}>
                      <Link to={`/renovaciones`}>
                        <div className="cr-widget card background-cards-servicios">
                          <div className="card-body">
                            <h5 className="card-title" style={{ color: "white" }}>Renovaciones</h5>
                          </div>
                          <div className="cr-widget__icon card-body">
                            <i className="fa fa-refresh fa-2x background-cards-iconos" aria-hidden="true"></i>
                          </div>
                        </div>
                      </Link>
                    </Col>
                  )}


                  {this.props.serviciosMenu.dataServicios.map(({ parCodigo, Nombre, Icon }) =>
                  {
                    console.log("parCodigo", `/pantalla-iframe/${parCodigo}`)
                    return <Col lg={6} md={6} sm={12} xs={12}>
                      <Link to={bloquearOpciones ? null : `/pantalla-iframe/${parCodigo}`} cursor='pointer'>
                      <div className={bloquearOpciones?"cr-widget card background-cards-servicios-disabled":"cr-widget card background-cards-servicios"}>
                          <div className="card-body">
                            <h5 className="card-title" style={{ color: "white" }}>{Nombre}</h5>
                          </div>
                          <div className="cr-widget__icon card-body">
                            <i className={`fa ${Icon} fa-2x background-cards-iconos`} aria-hidden="true"></i>
                          </div>
                        </div>
                      </Link>
                    </Col>
                  }
                    )
                  }
                  {/* <Col lg={6} md={6} sm={12} xs={12}>
                      <Link to={`/indemnizaciones`}>
                          <div className="cr-widget card background-cards-servicios">
                            <div className="card-body">
                              <h5 className="card-title" style={{ color: "white" }}>Indemnizaciones</h5>
                            </div>
                            <div className="cr-widget__icon card-body">
                              <i className="fa fa-balance-scale fa-2x background-cards-iconos" aria-hidden="true"></i>
                            </div>
                          </div>
                        </Link>
                  </Col>

                  <Col lg={6} md={6} sm={12} xs={12}>
                      <Link to={`/indemnizaciones`}>
                          <div className="cr-widget card background-cards-servicios">
                            <div className="card-body">
                              <h5 className="card-title" style={{ color: "white" }}>Indemnizaciones</h5>
                            </div>
                            <div className="cr-widget__icon card-body">
                              <i className="fa fa-handshake-o fa-2x background-cards-iconos" aria-hidden="true"></i>
                            </div>
                          </div>
                        </Link>
                  </Col> */}
                  {/* <Col lg={6} md={6} sm={12} xs={12}>
                    <div className="cr-widget card background-cards-servicios-disabled">
                      <div className="card-body">
                        <h5 className="card-title" style={{ color: "white" }}>Cartera-Cobranzas</h5>
                      </div>
                      <div className="cr-widget__icon card-body">
                        <i className="fa fa-money fa-2x background-cards-iconos" aria-hidden="true"></i>
                      </div>
                    </div>
                  </Col> */}
                  {/* <Col lg={6} md={6} sm={12} xs={12}>
                    <div className="cr-widget card background-cards-servicios-disabled">
                      <div className="card-body">
                        <h5 className="card-title" style={{ color: "white" }}>Tracking de Siniestros</h5>
                      </div>
                      <div className="cr-widget__icon card-body">
                        <i className="fa fa-exclamation-triangle fa-2x background-cards-iconos" aria-hidden="true"></i>
                      </div>
                    </div>
                  </Col> */}
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <div className="cr-widget card background-cards-servicios-disabled">
                      <div className="card-body">
                        <h5 className="card-title" style={{ color: "white" }}>Materiales</h5>
                      </div>
                      <div className="cr-widget__icon card-body">
                        <i className="fa fa-download fa-2x background-cards-iconos" aria-hidden="true"></i>
                      </div>
                    </div>
                  </Col>
                </CardGroup>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Page>

    );
  }
}

const mapStateToProps = state => ({
  datosDashboard: state.datosDashboard,
  datosUsuario: state.datosUsuarios,
  serviciosMenu: state.rServicios
});
const mapDispatchToProps = dispatch => {
  return {
  };
};
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Principal)
);
